<div class="card" style="margin-bottom: 0px; margin-top: 0px;font-family: Avenir,Avenir Next,Segoe UI,Helvetica,Arial,sans-serif;">
    <div class="card-header card-header-primary">
        <div class="row">
            <div class="col-sm-12 col-md-11">
                <h4 class="card-title"><b>Edición Solicitud Mejora</b></h4>
            </div>
            <div class="col-sm-12 col-md-1">
                <button mat-icon-button (click)="salir()" tabindex="0"><mat-icon>clear</mat-icon></button>
            </div>
        </div>
    </div>

    <div class="card-body">
        <div class="wraper">
            <div class="container">

                <!--Inicia Form ---------------------------------------------------------->
                <form [formGroup]='options'>
                    <div class="row">
                        <div class="col-sm-6 border-right">
                            <!--Asunto-->
                            <!-- <div class="col-sm-12" >
                                <mat-form-field>
                                    <mat-label> <b>Asunto</b> </mat-label>
                                    <input matInput placeholder="Asunto" formControlName='asuntoCtrl' [(ngModel)]="mejora.ticket.asunto" readonly>
                                </mat-form-field>
                            </div> -->
                            <!--Fecha Solicitud-->
                            <div class="col-sm-6">
                                <mat-form-field>
                                    <mat-label> <b>Fecha Solicitud</b> </mat-label>
                                    <input matInput placeholder="Fecha Solicitud" aria-label="Fecha Solicitud" formControlName='fechaSolicitudCtrl' [(ngModel)]="mejora.ticket.fechaSolicitud" readonly>
                                </mat-form-field>
                            </div>
                            <!--Area/Proyecto-->
                            <div class="col-sm-12" >
                                <mat-form-field >
                                    <mat-label> <b>Área/Proyecto al que aplica</b> </mat-label>
                                <input matInput placeholder="Área/Proyecto al que aplica" aria-label="Área/Proyecto al que aplica" formControlName='proyectoCtrl' [(ngModel)]="mejora.area_proyecto_aplica"  readonly >
                                </mat-form-field>
                            </div>
                            <!--justificacion-->
                            <div class="col-sm-12">
                                <mat-form-field>
                                    <mat-label> <b>Descripción Propuesta</b> </mat-label>
                                    <textarea matInput placeholder="Descripción Propuesta" aria-label="Descripción Propuesta" formControlName='justificacionCtrl'
                                            [(ngModel)]="mejora.ticket.justificacion" maxlength="512" readonly rows="5"></textarea>
                                </mat-form-field>
                            </div>
                             <!--Descripción-->
                            <div class="col-sm-12">
                                <mat-form-field>
                                    <mat-label> <b>Comentarios adicionales</b> </mat-label>
                                    <textarea required matInput placeholder="Comentarios adicionales" aria-label="Comentarios adicionales" formControlName='descripcionCtrl' 
                                                [(ngModel)]="descripcion" maxlength="500" readonly  rows="5"></textarea>
                                </mat-form-field>
                            </div>
                        </div>
                        <!--Evidencias-->
                        <div class="col-sm-6">
                            <div class="row">
                                <!--Tipo de solicitud-->
                                <div class="col-sm-6" >
                                    <mat-form-field disabled>
                                        <mat-label> <b> Tipo de Solicitud</b> </mat-label>
                                        <mat-select required formControlName='TipoSolicitudCtrl' [(ngModel)]="mejora.ticket.tipoSolicitud">
                                            <mat-option *ngFor="let items of tipoSolicitud" [value]="items.nombre"disabled>{{items.nombre}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <!-- <mat-error  *ngIf=' options.controls.TipoSolicitudCtrl.invalid && (options.controls.TipoSolicitudCtrl.dirty || options.controls.TipoSolicitudCtrl.touched) && options.controls.TipoSolicitudCtrl.errors.required'>
                                        El campo es requerido.</mat-error> -->
                                </div>
                                <!--Prioridad-->
                                <div class="col-sm-6" >
                                    <mat-form-field disabled>
                                        <mat-label> <b> Prioridad</b> </mat-label>
                                        <mat-select required formControlName='prioridadCtrl' [(ngModel)]="mejora.ticket.prioridad">
                                            <mat-option *ngFor="let items of prioridadesFiltradas" [value]="items.nombre" disabled>{{items.nombre}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <!-- <mat-error  *ngIf=' options.controls.prioridadCtrl.invalid && (options.controls.prioridadCtrl.dirty || options.controls.prioridadCtrl.touched) && options.controls.prioridadCtrl.errors.required'>
                                    El campo es requerido.</mat-error> -->
                                </div>
                                <!--Área Solicitante-->
                                <div class="col-sm-6">
                                    <mat-form-field>
                                        <mat-label> <b>Área Solicitante</b> </mat-label>
                                        <input matInput placeholder="Área Solicitante" aria-label="Área Solicitante" formControlName='areaCtrl' [(ngModel)]="mejora.ticket.areaSolicitante" readonly>
                                    </mat-form-field>
                                </div>
                                <!--Área Resolutora-->
                                <div class="col-sm-6">
                                    <mat-form-field>
                                        <mat-label> <b>Área Resolutora</b> </mat-label>
                                        <input matInput placeholder="Área Resolutora" aria-label="Área Resolutora" formControlName='areaResCtrl' [(ngModel)]="mejora.ticket.areaResolutora" readonly>
                                    </mat-form-field>
                                </div>
                                <!--Empresa-->
                                <div class="col-sm-6" >
                                    <mat-form-field>
                                        <mat-label> <b>Nombre Solicitante</b> </mat-label>
                                        <input matInput placeholder="Nombre Solicitante" aria-label="Nombre Solicitante" formControlName='nombreCtrl' [(ngModel)]="mejora.ticket.nombreSolicitante" readonly>
                                    </mat-form-field>
                                </div>
                                <!--Empresa-->
                                <div class="col-sm-6" >
                                    <mat-form-field>
                                        <mat-label> <b>Empresa Seleccionada</b> </mat-label>
                                        <input matInput placeholder="Empresa Seleccionada" aria-label="Empresa Seleccionada" formControlName='empresaCtrl' [(ngModel)]="nombreEmpresa" readonly>
                                    </mat-form-field>
                                </div>
                            
                            </div>
                        </div>
                    </div>
                </form>
                <!--Termina form ------------------------------------------------------------>

                <!-- <div class="row" >
                    <div class="col-sm-6 border-right ml-auto">
                        <div mat-dialog-actions class="justify-content-end">
                            <button mat-button class="btn btn-danger" (click)='salir()'  tabindex="11" >  
                                <i class="fa fa-times-circle-o"></i> Cancelar </button>
                            <button mat-button (click)='guardar()' class="btn  btn-success" [disabled]="!options.valid"  tabindex="12"   onClick="this.disabled=true">   
                                Guardar <i class='material-icons'> save </i> </button>
                        </div>
                    </div>
                </div> -->

            </div>
        </div>
    </div>

</div>